import * as Factory from 'factory.ts'
import faker from 'faker'

import { DepartmentMock } from './department.factory'
import { type SimpleUser, type User, type UserSetting } from '../../models'

export const UserMock = Factory.Sync.makeFactory<User>({
  id: Factory.each(() => faker.random.number()),
  firstName: Factory.each(() => faker.name.firstName()),
  lastName: Factory.each(() => faker.name.lastName()),
  email: Factory.each(() => faker.internet.email()),
  is_active: true,
  department: DepartmentMock.build(),
  address: faker.address.streetAddress(),
  approval_delegatee: null,
  created_at: faker.date.past(10).toISOString(),
  domains: {
    active: true,
    procurify_domains: [
      { subdomain: faker.random.word(), name: faker.random.word() },
    ],
  },
  headquarter_logo: '',
  is_approval_delegatee: false,
  is_sso_enabled: false,
  last_changed_by: null,
  mobile: false,
  notifications: null,
  pending_invite: false,
  phone: faker.phone.phoneNumber(),
  position: null,
  profile_image: Factory.each(() => faker.image.avatar()),
  role: null,
  slack_user_id: null,
  system_roles: [],
  systemaccess_cache: null,
  updated_at: faker.date.past(10).toISOString(),
  user: Factory.each(() => faker.random.number()),
  approval_permissions: ['approve_bill', 'approve_order'],
}).withDerivation1(['id'], 'user', (id) => {
  return id
})

export const SimpleUserMock = Factory.Sync.makeFactory<SimpleUser>({
  id: Factory.each(() => faker.random.number()),
  firstName: Factory.each(() => faker.name.firstName()),
  lastName: Factory.each(() => faker.name.lastName()),
  email: Factory.each(() => faker.internet.email()),
  approval_delegatee: null,
  position: null,
  profile_image: Factory.each(() => faker.image.avatar()),
  department: Factory.each(() => DepartmentMock.build()),
})

export const UserSettingMock = Factory.Sync.makeFactory<UserSetting>({
  id: Factory.each(() => faker.random.number()),
  edit_variance_type: 'dollar',
  modified_datetime: Factory.each(() => faker.date.past(10).toISOString()),
  restrict_editable_variance: true,
  user: UserMock.build(),
  variance_threshold_limit: '100.50',
})
